import {CalendarActionType} from "../../reducers/calendarReducer/types";
import {Dispatch} from "redux";
import {
    GetCountryAsync,
    GetCityAsync,
    GetCalendarAsync,
    GetCityByCountryAsync
} from "../../../services/api-calendar-service"
import {getLocalCitiesByCountry} from "../../../constants/country-list";

export const GetCountry = () => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CalendarActionType.START_REQUEST});
        const data = await GetCountryAsync();
        const response: any[] = data.response;
        dispatch({
            type: CalendarActionType.ALL_COUNTRIES_LOADED,
            payload: response.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())),
        });
    }
}

export const GetCity = (city: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CalendarActionType.START_REQUEST});
        const data = await GetCityAsync(city);
        const {response} = data;
        const res = [
            ...response.EQUALS,
            ...response.STARTS,
            ...response.CONTAINS
        ];
        dispatch({
            type: CalendarActionType.ALL_CITY_LOADED,
            payload: res,
        });
    }
}

export const GetCityByCountry = (country: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CalendarActionType.START_REQUEST});
        const data = await GetCityByCountryAsync(country);
        const {response} = data;
        const res = [
            ...response.EQUALS,
            ...response.STARTS,
            ...response.CONTAINS
        ];
        dispatch({
            type: CalendarActionType.ALL_CITY_LOADED,
            payload: res.map(item => item.city)
                .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())),
            // payload: res.map(item => item.city).concat(getLocalCitiesByCountry(country).map(city => city.name))
            //     .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())),
        });
    }
}

export const GetCalendar = (params: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CalendarActionType.START_REQUEST});
        const data = await GetCalendarAsync(params);
        const {response} = data;

        dispatch({
            type: CalendarActionType.CALENDAR_LOADED,
            payload: response,
        });
    }
}

export const LoadCalendarFromLoacalStorage = (params: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({
            type: CalendarActionType.CALENDAR_LOADED_FROM_LOCAL_STORAGE,
            payload: params,
        });
    }
}

export const GetYearCalendar = (params: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CalendarActionType.START_REQUEST});
        const data = await GetCalendarAsync(params);
        const {response} = data;
        dispatch({
            type: CalendarActionType.YEAR_CALENDAR_LOADED,
            payload: response,
        });
    }
}

export const GetPostPracticeCalendar = (params: any) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: CalendarActionType.START_REQUEST});
        const data = await GetCalendarAsync(params);
        const {response} = data;
        dispatch({
            type: CalendarActionType.POST_PRACTICE_CALENDAR_LOADED,
            payload: response,
        });
    }
}

export const ResetCalendar = () => {
    return async (dispatch: Dispatch) => {
        dispatch({
            type: CalendarActionType.CALENDAR_LOADED,
            payload: null,
        });
    }
}